import { render, staticRenderFns } from "./AnchorList.vue?vue&type=template&id=60ba915f&"
import script from "./AnchorList.vue?vue&type=script&lang=js&"
export * from "./AnchorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports